import React, {useState, useLayoutEffect } from 'react'
import {Detail} from './Detail'
import Comment from './Comment'
import { sectionStyle } from '../../components/Shared/Formating'
import {ToNotify} from 'fast_inon'

import {meSplitter} from '../../components/Shared/meLayout'

const NoteControl = ({global, element, onElement, editing, onLoad, search}) => {

    const detail = new meSplitter("NoteSide", "Note", false)
    const [message, Message] = useState('')

    useLayoutEffect (()=>{  
            detail.selectorAll()       
        },[])
    

return (
    <div className="Sides" id="NoteContainer"
            onMouseDown={(e)=>{detail.mouseDown(e)}} 
            onMouseMove={(e)=>{detail.mouseMove(e)}} 
            onMouseUp={(e)=>{detail.mouseUp(e)}}
        >
        <div className="side hside" id="NoteSideNote" style={{height: '30%'}}>
            <Detail global={global} id={element} onStyle={sectionStyle} LoadNotes={onLoad} onNote={onElement} editing={editing} onMessage={Message} />
        </div>
        <div className="side hside" id="NoteSideTimer" style={{height: '70%'}}>
            <Comment global={global} note={element} onStyle={sectionStyle} onMessage={Message} />
        </div>

<ToNotify 
message={message}
onClose={()=>Message('')}
/>          
    </div>


     )
}

export default NoteControl
